import React from 'react';

import { ImageURISource } from 'react-native';

import { MarkerTypes } from 'hooks/use-map/types';

export { MarkerTypes };

export interface IMarkerInput {
  id: string;
  type: MarkerTypes;
  location: CenterPoint;
  onPress?: () => void;
  title?: string;
  isSelected?: boolean;
  isFocused?: boolean;
  enableMapListExperiment?: boolean;
  visible?: boolean;
}

export interface IMarker extends IMarkerInput {
  icon: React.ReactNode | ImageURISource | string; // changed to maintain compatibility between WEB and APP
  preventMarkerPress: boolean;
}

export type PanToFn = (
  newPosition: {
    lat?: number | null;
    lng?: number | null;
  } | null,
  animationTime?: number,
  shouldUseActualZoom?: boolean,
  zoomToUse?: number
) => void;

export type FitAndCenterFromCoordsFn = (coordsArray: CenterPoint[]) => void;

export type CenterPoint = {
  lat: number;
  lng: number;
};

export type CenterPointExperiment = {
  lat: number;
  lng: number;
  accuracy?: number;
  zoom?: number;
};

export interface IUseMapHookExperimentParam {
  startPosition?: CenterPointExperiment | null;
  disableControls?: boolean;
  onDragEnd: () => void;
}

export type IUseMapHookExperiment = (
  args: IUseMapHookExperimentParam
) => {
  actualMapCenterLatLng: CenterPointExperiment;
  mapComponent: React.ReactNode;
  renderMarkers: (markers: React.ReactNode[] | void) => void;
  createMarker: (args: IMarker) => null | React.ReactNode;
  createMarkerList: (args: IMarker[]) => React.ReactNode[] | void;
  focusToPoint: PanToFn;
  focusToPoints: (coords: any[]) => void;
  getCurrentCenter: () => CenterPointExperiment;
};
